export const projects = [
  {
    title: "My Portfolio",
    description:
      "My Portfolio Contains All the Projects I Have Done So Far. It is a React Application.Also It Contains Basic Information About Me.",
    image: "/images/8.png",
    source: "https://bhavik-portfolio.netlify.app/",
    id: 1,
    alt: "My Portfolio",
  },
  {
    title: "Youtube Clone",
    description:
      "This App is called Youtube clone it contains Use of rapid api and materialize Ui",
    image: "/images/16.png",
    source: "https://yt2-clone.netlify.app/",
    id: 2,
    alt: "Yt2",
  },
  {
    title: "ShopEase",
    description:
      "Created an e-commerce application to showcase my skills using Redux and React.js, with a backend built on Node.js and PostgreSQL, following highly optimized approaches",
    image: "/images/shop.png",
    source: "https://shop-ecom-ease.netlify.app/",
    id: 5,
    alt: "shopease-ecommerce-app",
  }
  ,
  {
    title: "CodewithWorld",
    description:
      "This is my YT channel where i showcase my skills and teach students like me.",
    image: "/images/18.png",
    source: "https://code-with-world.netlify.app/",
    id: 5,
    alt: "Unsplash Clone",
  },
  {
    title: "Mern TODO App",
    description:
      "This is a simple todo but technologies contained are Node(express),React,Mongodb",
    image: "/images/17.png",

    source: "https://github.com/Bhavik-prajapati/MernTodoApp.git",
    id: 3,
    alt: "TODO App",
  },
  {
    title: "Property-listing",
    description:
      "The App is called Brickease- and it is a simple  app that allows users to contact his/her required place to stay and rent and pg or buy house.",
    image: "/images/prop.png",
    source: "https://github.com/Bhavik-prajapati/plwa-web-app",
    id: 4,
    alt: "Unsplash Clone",
  },
];
export const Langs = [
  {
    logo: "fa-brands fa-react",
    title: "Front-End",
    langname: "React Js",
    id: 1,
  },
  {
    logo: "fa-brands fa-node-js",
    title: "Back-End",
    langname: "Node and Database",
    id: 2,
  },
  {
    logo: "fa-brands fa-figma",
    title: "Ui/Ux",
    langname: " tools like Figma",
    id: 3,
  },
  {
    logo: "fa-brands fa-git-alt",
    title: "Git/Github",
    langname: " tools like Git and Github",
    id: 4,
  },
  {
    logo: "fa-solid fa-bezier-curve",
    title: "Ps/Ai",
    langname: " tools like Photoshop and Illustrator",
    id: 5,
  },
  {
    logo: "fa-solid fa-arrow-pointer",
    title: "Research",
    langname: " Tools like Google and StackOverflow",
    id: 6,
  },
];

export const anims = [
  {
    id: 2,
    title: "Mountain",
    image: "/images/9.png",
    link: "https://codepen.io/rahul429-wq/pen/vYedKbP",
  },
  {
    id: 1,
    title: "Todo",
    image: "/images/15.png",
    link: "https://codepen.io/rahul429-wq/pen/MWpaLxW",
  },
  {
    id: 3,
    title: "Bicycle",
    image: "/images/10.png",
    link: "https://codepen.io/rahul429-wq/pen/LYWNdWW",
  },
  {
    id: 5,
    title: "Solar system",
    image: "/images/151.png",
    link: "https://codepen.io/rahul429-wq/pen/ZEVpmpL",
  },
  {
    id: 4,
    title: "Explore",
    image: "/images/13.png",
    link: "https://codepen.io/rahul429-wq/pen/yLMqppj",
  },
];
